export const MAX_ALLOWED_IMAGES = 16;
